
import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { AppSettings } from '../../app.settings';

@Component({
    selector: 'app-seat-layout',
    templateUrl: './seat-layout.component.html',
    standalone: false
})
export class SeatLayoutComponent implements OnInit {
  @Input() seatLayouts: any[];
  @Input() orientation;
  @Input() deckWidth = 0;
  @Input() deckHeight = 0;
  @Input() interactive;
  @Output() availableSeat: EventEmitter<any> = new EventEmitter();
  @Output() bookedSeat: EventEmitter<any> = new EventEmitter();
  hasShown = false;
  displayMessage = '';

  constructor(
    private commonBindingDataService: CommonBindingDataService
  ) { }

  ngOnInit() {
    this.ProcessSeatLayoutData();
  }

  ProcessSeatLayoutData() {
    for (let layout = 0; layout < this.seatLayouts.length; layout++) {
      const seat = this.seatLayouts[layout];
      if (this.orientation !== 'horizontal') {
        seat.index = this.seatLayouts.length - layout;
        seat.width = this.widthPercentageToPx(seat.width);
        seat.height = this.widthPercentageToPx(seat.height);
        seat.x = this.widthPercentageToPx(seat.x);
        seat.y = this.widthPercentageToPx(seat.y);
      } else {
        seat.index = this.seatLayouts.length - layout;
        seat.width = this.widthPercentageToPx(seat.height);
        seat.height = this.widthPercentageToPx(seat.width);
        seat.x = this.widthPercentageToPx(seat.y);
        seat.y = this.widthPercentageToPx(seat.x) - seat.height;
      }
    }
  }

  widthPercentageToPx(percentage) {
    let width = this.deckWidth;
    if (this.orientation === 'horizontal') {
      width = this.deckHeight;
    }
    return width * percentage / 100;
  }

  onEmptySeatClick(seat) {
    if (this.interactive === 'interactive') {
      if (seat.locked && seat.isSelected) {
        seat.locked = false;
      }

      if (seat.seatClass === 'ADA' && seat.isSelected) {
        return;
      }

      // if (!this.checkIfSeatSelectionAvailable(seat)) {
      //   this.displayMessage = this.commonBindingDataService.getLabel('label_error_non_convertible_seat_selected');
      //   return;
      // }

      // seat.isSelected = !seat.isSelected;
      if (seat.isSelected && (seat.seatNumber === '1' || seat.seatNumber === '2')) {
        this.displayMessage = this.commonBindingDataService.getLabel('label_reverse_seat');
      }

      if (this.interactive) {
        this.availableSeat.emit(seat);
      }
    } else if (this.interactive === 'non-interactive') {
      if (seat.locked && seat.isSelected) {
        seat.locked = false;
      }

      if (seat.seatClass === 'ADA' && seat.isSelected) {
        return;
      }
      this.availableSeat.emit(seat);
    }
  }

  onBookedSeatClick(event, seatNo) {
    if (this.interactive) {
      const obj = {
        event: event,
        seatNo: seatNo
      };
      this.bookedSeat.emit(obj);
    }
  }

  checkIfSeatSelectionAvailable(seat) {
    const adaSeats = this.seatLayouts.filter(s => s.seatClass === 'ADA');

    switch (adaSeats.length) {
      case 0:
        // Check if all non convertible seats are selected.
        if (!seat.isSelected) {
          const nonConvertibleSeats = this.seatLayouts
            .filter(s => !AppSettings.NormalSeatsIfNoADA.includes(s.seatNumber)
              && (!s.occupied && !s.isSelected) && s.seatNumber !== 'Table');
          if ((nonConvertibleSeats.length === 0)
            || nonConvertibleSeats.length > 0 && nonConvertibleSeats.filter(s => s.seatNumber === seat.seatNumber).length > 0) {
            return true;
          }
        }

        // if any non convertible seat is selected then all selected convertible seats are unselected.
        if (seat.isSelected && !AppSettings.NormalSeatsIfNoADA.includes(seat.seatNumber)) {
          const convertibleSeats = this.seatLayouts.filter(s => AppSettings.NormalSeatsIfNoADA.includes(s.seatNumber) && s.isSelected);

          convertibleSeats.forEach(s => {
            s.isSelected = false;
          });
          return true;
        }

        // Allowed to select.
        if (seat.isSelected) {
          return true;
        }
        return false;
      case 1:
        // Check if all non convertible seats are selected.
        if (!seat.isSelected) {
          const nonConvertibleSeats = this.seatLayouts
            .filter(s => !AppSettings.NormalSeatsIfOneADA.includes(s.seatNumber)
              && (!s.occupied && !s.isSelected) && s.seatNumber !== 'Table');
          if ((nonConvertibleSeats.length === 0)
            || nonConvertibleSeats.length > 0 && nonConvertibleSeats.filter(s => s.seatNumber === seat.seatNumber).length > 0) {
            return true;
          }
        }

        // if any non convertible seat is selected then all selected convertible seats are unselected.
        if (seat.isSelected && !AppSettings.NormalSeatsIfOneADA.includes(seat.seatNumber)) {
          const convertibleSeats = this.seatLayouts.filter(s => AppSettings.NormalSeatsIfOneADA.includes(s.seatNumber) && s.isSelected);

          convertibleSeats.forEach(s => {
            s.isSelected = false;
          });
          return true;
        }

        // Allowed to select.
        if (seat.isSelected) {
          return true;
        }
        return false;
      case 2:
        // Allow selection.
        return true;
    }
  }

  onHide(event) {
    this.displayMessage = '';
  }
}
